module.exports = {"320925001":"近湖街道","320925050":"开发区（钟庄街道）","320925051":"高新区（塘河街道）","320925101":"建阳镇","320925102":"九龙口镇","320925103":"恒济镇","320925104":"颜单镇","320925105":"沿河镇","320925106":"芦沟镇","320925107":"庆丰镇","320925108":"上冈镇","320925111":"冈西镇","320925113":"宝塔镇","320925114":"高作镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320925.json
// module id = 911
// module chunks = 0